// Stellalith Crystal — Theme JavaScript
// Smooth scroll for anchor links, cart count update, image gallery

document.addEventListener('DOMContentLoaded', function() {
  
  // Smooth scroll for all anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Product gallery thumbnails
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.querySelector('.product-main-image');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = this.src.replace(/_\d+x\./, '_800x.');
        thumbs.forEach(function(t) { t.style.opacity = '0.6'; });
        this.style.opacity = '1';
      });
    });
  }

  // Cart count update (listen for Shopify cart changes)
  document.addEventListener('cart:updated', function(e) {
    var countEl = document.querySelector('[data-cart-count]');
    if (countEl && e.detail && e.detail.cart) {
      countEl.textContent = e.detail.cart.item_count || '';
    }
  });

});


  // Mobile menu toggle (added) — [AUDIT FIX] also toggle `inert` so focus can't
  // land on hidden links while the menu is closed (WCAG 2.4 focus trap fix).
  var burger = document.querySelector('.header-burger');
  var mobileMenu = document.getElementById('mobile-menu');
  if (burger && mobileMenu) {
    function setInert(state) {
      if (state) mobileMenu.setAttribute('inert', '');
      else mobileMenu.removeAttribute('inert');
    }
    setInert(mobileMenu.getAttribute('aria-hidden') === 'true');
    burger.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      burger.classList.toggle('is-active', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      burger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      setInert(!isOpen);
    });
    mobileMenu.querySelectorAll('.mobile-link').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        burger.classList.remove('is-active');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Open menu');
        mobileMenu.setAttribute('aria-hidden', 'true');
        setInert(true);
      });
    });
  }
